<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">ENVIAR NOTIFICACIONES</h1>
        </section>

        <form [formGroup]="notificationForm" (ngSubmit)="saveChanges(notificationForm.value)">
            <mat-card>
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                    <div fxFlex="100">
                        <mat-form-field appearance="outline">
                            <mat-label>Título</mat-label>
                            <input type="text" matInput formControlName="title">
                            <mat-error *ngIf="notificationForm.controls['title'].hasError('required')">
                            Este campo es obligatorio
                            </mat-error>
                            <mat-error *ngIf="notificationForm.controls['title'].hasError('cannotContainSpace')">
                                Ingrese un título
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                    <div fxFlex="100">
                        <mat-form-field appearance="outline">
                            <mat-label>Descripción(menos de 250 palabras)</mat-label>
                            <textarea rows="10" cols="40" maxlength="250" matInput formControlName="description"></textarea>
                            <mat-error *ngIf="notificationForm.controls['description'].hasError('required')">
                            Este campo es obligatorio
                            </mat-error>
                            <mat-error *ngIf="notificationForm.controls['description'].hasError('cannotContainSpace')">
                                Ingrese una descripción
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                    <div fxFlex="100">
                        <mat-form-field appearance="outline">
                            <mat-label>Contraseña de confirmación</mat-label>
                            <input type="password" matInput formControlName="password" placeholder="Contraseña">
                            <mat-error *ngIf="notificationForm.controls['password'].hasError('required')">
                            Este campo es obligatorio  
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button type="submit" [disabled]="!notificationForm.valid" mat-raised-button class="save-changes">ENVIAR</button>
                    <button routerLink="/admin-home" mat-raised-button class="cancel-changes">CANCELAR</button>
                </div>
            </mat-card>
        </form>

    </div>
</div>